<template>
  <b-container
    fluid
    class="GallerySection"
  >
    <b-row class="GallerySection__contents">
      <b-col
        v-for="item in items"
        :key="item.index"
        class="GallerySection__item"
        cols="6"
        md="6"
        lg="3"
      >
        <a
          href="#"
          class="GallerySection__item-link"
        >
          <img
            :src="`${item.image.filename}/m/500x500/smart`"
            :alt="item.title"
            class="img-fluid GallerySection__image"
          >
          <div class="GallerySection__item-overlay">
            <span class="GallerySection__item-overlay__content">{{ item.title }}
              <span class="GallerySection__item-overlay__subline">{{ item.subline }}</span>
            </span>
          </div>
        </a>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  components: { },
  props     : {
    items: {
      type   : Array,
      default: null,
    },
  },
}
</script>

<style lang="scss">
    .GallerySection {

        padding: 0px;

        &__contents {
            margin: 0px;
        }

        &__item {
            padding-right: 0px !important;
            padding-left: 0px !important;
        }

        &__item-link {
            &:hover {
                .GallerySection__item-overlay {
                    opacity: .8;
                }
            }
        }

        &__item-overlay {
            transition: opacity 0.2s;
            opacity: 0;
            position: absolute;
            background: $primary;
            width: 100%;
            height: 100%;
            margin-top: -20em;
            font-weight: 800;
            display: flex;
            justify-content: center;
            font-family: $font-family-serif;
            text-align: center;

            &__content {
                display: block;
                align-self: center;
                color: $light;
                font-size: 2em;
            }

            &__subline {
              display: block;
              font-family: $font-family-sans-serif;
              font-weight: 500;
              font-size: 0.5em;
            }
        }

        &__image {
            object-fit: cover;
            height: 20em !important;
            width: 100%;
        }
    }
</style>
